import { useGetClientHeaderInfoQuery } from 'modules/Clients/services/clientsApi'

interface Props {
  clientId?: string
}
export const useClientHeaderInfo = ({ clientId }: Props) => {
  const { data, isFetching } = useGetClientHeaderInfoQuery({
    params: {
      clientId: clientId || '',
    },
  })

  return {
    clientDetail: data?.result || null,
    isFetching,
  }
}
